const PROJECT_ID_QUERY_PARAM = 'projectid';

export const trimLeadingSlashes = (path: string): string => {
  // Sometimes when we combine url parts with folders, we need to ensure we don't create "//"
  let trimmedPath = path.replace(/^\/+/, '');
  return trimmedPath;
};

export const projectIdURLParam = (projectId: string | null): string => {
  if (projectId) {
    let newParams = new URLSearchParams();
    newParams.set(PROJECT_ID_QUERY_PARAM, projectId);
    return newParams.toString();
  } else return '';
};
